<template>
    <div id="confirm-page">
        <loading-overlay :active.sync="displayLoader" loader="dots" color="#1A74DB" height="30" width="100%" opacity="0.85"></loading-overlay>
        <div v-if="pageDataFetched">
            <checkout-header
                :categoryFilter="{display: false}"
                :shoppingBag="{display: false}">
            </checkout-header>
            <div class="relative">
                <img class="w-full object-cover h-full" :src="bannerURL">
                <div class="child text-center">
                    <img class="m-auto" :src="checkImage" />
                    <div class="font-medium text-5xl pt-1">{{this.header}}</div>
                    <div class="pt-1">{{this.bodyHeader}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapMutations, mapActions } from "vuex";
    import axios from 'axios';
    import CheckoutHeader from '../../layouts/header';


    export default {

        components: {CheckoutHeader},

        data() {
            return {
                pageDataFetched: false,
                header: '', 
                bodyHeader: '', 
                bodyText: '',
                bannerURL: '',
                checkImage: ''
            }
        },

        computed: {
            ...mapGetters('checkout', [
                'autoRenewalOptOut'
            ]),
            ...mapGetters('content', [
                'renewalsPersistedVariables'
            ]),
        },
        methods: {
            ...mapMutations('checkout', [
                'setAutoRenewalOptOut'
            ]),
            ...mapActions('content',[
                'getRenewalsPersistedVariables'
            ]),
        },

        async created() {
            try {
                let confirmPageData = await axios('/checkout/confirm-renewal-page-data');
                await this.getRenewalsPersistedVariables();
                this.header = confirmPageData.data.header
                this.bodyHeader = confirmPageData.data.bodyHeader
                this.bodyText = confirmPageData.data.bodyText
                this.bannerURL = confirmPageData.data.banner
                this.checkImage = confirmPageData.data.checkImage
            } catch(e) {
                this.$router.push({path: '/message', query: {type: 'orderConfirmed'}});
                return;
            }
            this.pageDataFetched = true;
        },


    }

</script>

<style scoped>

    

    a{
        color: #0000EE;
    }

    img {
        height: auto;
    }

    .child{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%)
    }


</style>